import React from 'react';
import '../styles/VirtualKeyboard.css';

const keyboardLayoutLabels = [
  ['1','2','3','4','5','6','7','8','9','0'],
  ['Q','W','E','R','T','Y','U','I','O','P'],
  ['粤','A','S','D','F','G','H','J','K','L'],
  ['港','澳','Z','X','C','V','B','N','M','⌫'],
];

const disabledKeys = {
  'Q': true,
  'I': true,
  'O': true
};

const getKeyType = (label) => {
  if (label === '⌫') {
    return 'backspace';
  }
  
  if (/^[0-9]$/.test(label)) {
    return 'number';
  }
  if (/^[A-Z]$/.test(label)) {
    return 'letter';
  }

  // Chinese character
  return 'special';
};

const getKeyClassNames = (type, disabled) => {
  let classNames = ["keyboard-key"];

  if (type === "number") {
    classNames.push("number-key");
  } else if (type === "letter") {
    classNames.push("letter-key");
  } else if (type === "special") {
    classNames.push("special-key");
  } else if (type === "backspace") {
    classNames.push("backspace-key");
  }
  if (disabled) {
    classNames.push("disabled-key");
  }
  return classNames.join(" ");
};

const keyboardLayout = keyboardLayoutLabels.map((row) =>
  row.map(label => {
    const disabled = disabledKeys[label] || false;
    const type = getKeyType(label);
    return {
      label,
      disabled,
      type,
      className: getKeyClassNames(type, disabled)
    };
  })
);

const VirtualKeyboard = ({ onKeyPress, onBackspace }) => {
  const handleKeyClick = (key) => {
    onKeyPress(key);
  };

  const handleBackspace = () => {
    onBackspace();
  };

  return (
    <div className="virtual-keyboard">
      {keyboardLayout.map((row, rowIndex) => (
        <div className="keyboard-row" key={rowIndex}>
          {row.map((keyObj, keyIndex) => {
            if (keyObj.type === 'backspace') {
              return (
                <button
                  key={keyObj.label}
                  type="button"
                  className={keyObj.className}
                  onClick={handleBackspace}
                >
                  {keyObj.label}
                </button>
              );
            }

            return (
              <button
                key={keyObj.label}
                type="button"
                className={keyObj.className}
                onClick={() => handleKeyClick(keyObj.label)}
                disabled={keyObj.disabled}
              >
                {keyObj.label}
              </button>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default VirtualKeyboard;
